export function adjustTextImagesToProperFormat(textImages) {
  if (Array.isArray(textImages)) {
    return textImages;
  }
  if (!textImages) {
    return [];
  }
  return Object.keys(textImages).reduce((allImages, location) => [...allImages, ...textImages[location]], []);
}